import { BackendRoute } from '../../../../config/index';
import { QueryKey } from '../../../../constants/index';
import { useAppQuery } from '../../../../hooks/use-app-query.hook';
import ApiService from '../../../../services/api-service.util';

export type TemplatePreviewParams = {
  companyId?: null | string;
  planId?: null | string;
  stakeholderId?: null | string;
};

export type TemplatePreviewResult = Record<string, string>;

export const useTemplatePreview = (
  templateId: null | string,
  params: TemplatePreviewParams,
  enabled: boolean,
) => {
  const { companyId, planId, stakeholderId } = params;
  const hasAnchors = !!templateId && enabled && (!!planId || !!stakeholderId || !!companyId);

  const { data, isPending, isError } = useAppQuery<TemplatePreviewResult>({
    queryKey: [
      QueryKey.GET_TEMPLATE_PREVIEW,
      templateId,
      companyId ?? '',
      planId ?? '',
      stakeholderId ?? '',
    ],
    queryFn: () =>
      ApiService.get<TemplatePreviewResult>(
        {
          endpoint: BackendRoute.TEMPLATES,
          routePath: [templateId!, 'preview'],
        },
        {
          queryParams: {
            ...(companyId && { companyId }),
            ...(planId && { planId }),
            ...(stakeholderId && { stakeholderId }),
          },
        },
      ),
    enabled: !!hasAnchors,
  });

  return {
    fillValues: data ?? {},
    isError,
    isPending,
  };
};
